import { Machine, assign, sendParent } from 'xstate';
import isEqual from 'react-fast-compare';
const isDifferent = (ctx, event) => {
  return !isEqual(ctx.value, event.value);
};
export const inputMachine = () => Machine({
  id: 'input-machine',
  type: 'parallel',
  context: {
    errorMessage: undefined,
    name: '',
    value: undefined
  },
  states: {
    active: {
      initial: 'blurred',
      on: {
        COMMIT: {
          actions: ['sendValueToParent'],
          in: '#input-machine.pristine.dirty'
        },
        SET: {
          cond: isDifferent,
          actions: ['setValue']
        }
      },
      states: {
        blurred: {
          on: {
            FOCUS: 'focused'
          }
        },
        focused: {
          on: {
            BLUR: {
              actions: ['sendValueToParent'],
              in: '#input-machine.pristine.dirty',
              target: 'blurred'
            },
            CHANGE: {
              actions: 'setValue'
            }
          }
        }
      }
    },
    pristine: {
      initial: 'pristine',
      states: {
        pristine: {
          on: {
            CHANGE: {
              target: 'dirty'
            }
          }
        },
        dirty: {
          on: {
            COMMIT: {
              target: 'pristine'
            },
            SET: {
              target: 'pristine'
            }
          }
        }
      }
    },
    touched: {
      initial: 'untouched',
      states: {
        untouched: {
          on: {
            FOCUS: 'touched'
          }
        },
        touched: {}
      }
    },
    validity: {
      initial: 'valid',
      states: {
        invalid: {
          on: {
            SET_VALID: {
              target: 'valid',
              cond: ctx => !!ctx.errorMessage,
              actions: 'resetErrorMessage'
            },
            SET_INVALID: {
              target: 'invalid',
              actions: 'setErrorMessage'
            }
          }
        },
        valid: {
          on: {
            SET_INVALID: {
              target: 'invalid',
              actions: 'setErrorMessage'
            }
          }
        }
      }
    }
  }
}, {
  actions: {
    resetErrorMessage: assign(ctx => {
      ctx.errorMessage = undefined;
      return ctx;
    }),
    setErrorMessage: assign((ctx, err) => {
      ctx.errorMessage = err.errorMessage;
      return ctx;
    }),
    //https://github.com/davidkpiano/xstate/issues/866
    setValue: assign((ctx, event) => {
      //should use produce here
      ctx.value = event.value;
      return ctx;
    }),
    sendValueToParent: sendParent(ctx => ({
      name: ctx.name,
      type: 'INPUT',
      value: ctx.value
    }))
  }
});